import React, { useEffect } from 'react'
import useMediaRecorder from '../../hooks/useMediaRecorder'
import Button from '../ui/Button'
import styles from './VideoRecorder.module.css'

export default function VideoRecorder({ onRecorded }) {
  const {
    isRecording,
    elapsedSeconds,
    maxSeconds,
    startRecording,
    stopRecording,
    recordedBlob,
    reset,
  } = useMediaRecorder()

  useEffect(() => {
    if (recordedBlob) {
      onRecorded?.(recordedBlob)
    }
  }, [recordedBlob, onRecorded])

  const formatTime = (s) => {
    const m = Math.floor(s / 60)
    const sec = s % 60
    return `${m}:${sec.toString().padStart(2, '0')}`
  }

  const progress = (elapsedSeconds / maxSeconds) * 100
  const isLastTen = elapsedSeconds >= maxSeconds - 10

  return (
    <div className={styles.wrap}>
      <div className={styles.header}>
        <div className={styles.status}>
          {isRecording && (
            <>
              <span className={styles.dot} aria-hidden="true" />
              <span className={styles.recordingText}>Recording</span>
            </>
          )}
        </div>
        <div className={styles.timer} aria-live="polite">
          {formatTime(elapsedSeconds)} / {formatTime(maxSeconds)}
        </div>
      </div>
      <div className={styles.progressWrap}>
        <div
          className={[styles.progressBar, isLastTen && styles.progressBarWarning]
            .filter(Boolean)
            .join(' ')}
          data-progress={Math.round(progress)}
          aria-hidden="true"
        />
      </div>
      <div className={styles.controls}>
        {!isRecording && elapsedSeconds === 0 && (
          <Button onClick={startRecording} size="lg">
            Start recording
          </Button>
        )}
        {isRecording && (
          <Button onClick={stopRecording} variant="danger" size="lg">
            Stop recording
          </Button>
        )}
        {!isRecording && elapsedSeconds > 0 && !recordedBlob && (
          <Button loading size="lg">
            Processing
          </Button>
        )}
      </div>
    </div>
  )
}
